////////////////////////////////////////////////////
// MAIN PRODUCT + MEMBERSHIP ADD TO CART (SHOPFLO)
////////////////////////////////////////////////////

$(document).ready(function () {

  const membershipHandle = "quarterly-membership";

  /* ---------------- UTILITIES ---------------- */

  // Add product to cart by variant ID
  function addProduct(variantId, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function () {
        if (callback) callback();
      },
      error: function (err) {
        console.error('Add to cart error:', err.responseText);
      }
    });
  }

  // Add membership if missing (CHECK AFTER main product add)
  function addMembershipIfMissing(callback) {
    $.getJSON('/cart.js', function (cart) {

      const hasMembership = cart.items.some(
        item => item.handle === membershipHandle
      );

      if (hasMembership) {
        callback();
        return;
      }

      $.getJSON(`/products/${membershipHandle}.js`, function (product) {
        const membershipVariantId = product.variants[0].id;
        addProduct(membershipVariantId, callback);
      });

    });
  }

  // Open Shopflo cart (SUPPORTED METHOD)
  function openShopfloCart() {
    if (typeof window.handleFloCartBtn === 'function') {
      window.handleFloCartBtn();
    } else {
      $('#flo-cart-icon')[0]?.click();
    }
  }

  /* ---------------- MEMBER PRICE ADD TO CART ---------------- */

  // $(document).on('click', '.bothmembergift_addtocart', function (e) {
  //   e.preventDefault();

  //   const $btn = $(this);
  //   const $form = $btn.closest('form'); // 🔐 safe variant source
  //   const $loader = $btn.find('.loader-button__loader');

  //   const mainVariantId = $form.find('input[name="id"]:checked, input[name="id"]').val();

  //   if (!mainVariantId) return;

  //   $loader.show();
  //   $btn.prop('disabled', true);

  //   // 1️⃣ Add MAIN product
  //   addProduct(mainVariantId, function () {

  //     // 2️⃣ Add MEMBERSHIP if not in cart
  //     addMembershipIfMissing(function () {

  //       // 3️⃣ Open Shopflo cart AFTER sync
  //       setTimeout(function () {
  //         openShopfloCart();
  //       }, 400);

  //       $loader.hide();
  //       $btn.prop('disabled', false);
  //     });

  //   });
  // });

});


////////////////////////////////////////////////////
// MEMBER PRICE / REGULAR PRICE BUTTON TOGGLE (UNCHANGED)
////////////////////////////////////////////////////

function toggleButtons() {

  function setDisplayImportant(selector, value) {
    $(selector).each(function () {
      this.style.setProperty('display', value, 'important');
    });
  }

  if ($('.priceopt_member').hasClass('selected')) {
    $('.addto_specialbtn').addClass('addto_normalbtn bothmembergift_addtocart').removeClass('addtocart_popupbtn');
    setDisplayImportant('.proceed-to-checkout button.checkout-button', 'none');
  } else {
    $('.addto_specialbtn').addClass('addtocart_popupbtn').removeClass('addto_normalbtn bothmembergift_addtocart');
    setDisplayImportant('.proceed-to-checkout button.checkout-button', 'block');
  }
}

// Initial run
toggleButtons();

// Keep in sync with variant / UI changes
setInterval(toggleButtons, 300);

// Membership radio UI
$(document).on('click', '.membership-radio-card', function () {
  $('.membership-radio-card').removeClass('active');
  $(this).addClass('active');
  $(this).find('input[type="radio"]').prop('checked', true);
  toggleButtons();
});


////////////////////////////////////////////////////
// COLLECTION PAGE "JOIN NOW" (MEMBERSHIP ONLY)
////////////////////////////////////////////////////

$(document).ready(function () {

  const membershipHandle = "quarterly-membership";

  function addProduct(variantId, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function () {
        if (callback) callback();
      }
    });
  }

  function openShopfloCart() {
    if (typeof window.handleFloCartBtn === 'function') {
      window.handleFloCartBtn();
    } else {
      $('#flo-cart-icon')[0]?.click();
    }
  }

  $('body').on('click', '.memcollpage_joinbtn', function (e) {
    e.preventDefault();

    $.getJSON('/cart.js', function (cart) {

      const hasMembership = cart.items.some(
        item => item.handle === membershipHandle
      );

      if (hasMembership) {
        openShopfloCart();
        return;
      }

      $.getJSON(`/products/${membershipHandle}.js`, function (product) {
        addProduct(product.variants[0].id, function () {
          setTimeout(openShopfloCart, 400);
        });
      });

    });
  });
});
